export const BRAND_LIST = [
  { slug: "Lexpure", name: "Lexpure" },
  { slug: "Cruze", name: "Cruze" },
];
export const REG_TYPE_DOMESTIC_SLUG = "domestic";
export const REG_TYPE_LIST = [
  { slug: REG_TYPE_DOMESTIC_SLUG, name: "Domestic" },
  { slug: "industrial", name: "Industrial" },
];
export const SCANNING_REPORT_INTERVAL = [
  { slug: "daily", name: "Daily" },
  { slug: "weekly", name: "Weekly" },
  { slug: "half_month", name: "Half Month" },
  { slug: "monthly", name: "Monthly" },
];
export const SCANNING_REMINDER_INTERVAL = [
  { slug: "daily", name: "Daily" },
  { slug: "weekly", name: "Weekly" },
  { slug: "half_month", name: "Half Month" },
  { slug: "monthly", name: "Monthly" },
];
export const PRODUCT_TRANSFER_REMINDER_INTERVAL = [
  { slug: "daily", name: "Daily" },
  { slug: "weekly", name: "Weekly" },
  { slug: "half_month", name: "Half Month" },
  { slug: "monthly", name: "Monthly" },
];
export const PRODUCT_CLAIM_REMINDER_INTERVAL = [
  { slug: "daily", name: "Daily" },
  { slug: "weekly", name: "Weekly" },
  { slug: "half_month", name: "Half Month" },
  { slug: "monthly", name: "Monthly" },
];
export const OTHER_PRODUCT_SCAN = [
  { slug: "daily", name: "Daily" },
  { slug: "weekly", name: "Weekly" },
  { slug: "half_month", name: "Half Month" },
  { slug: "monthly", name: "Monthly" },
];
export const ROLE = [
  { slug: "dealer", name: "Dealer" },
  { slug: "retailer", name: "Sub-Dealer" },
  { slug: "technician", name: "Technician" },
];

export const ACHIEVERS_SHOW_FILTER = [
  { slug: "yes", name: "Yes" },
  { slug: "no", name: "No" },
];
export const OUTLET_DISPLAY_SETTING = [
  { slug: "yes", name: "On" },
  { slug: "no", name: "Off" },
];
export const ACHIEVERS_SHOW = [
  { slug: "1", name: "Yes" },
  { slug: "0", name: "No" },
];
export const FIVE_START_GIFT_COMPLETED_OPTION_LIST = [
  { slug: 1, name: "Yes" },
  { slug: 0, name: "No" },
];
export const SCAN_ALLOW_FILTER = [
  { slug: "yes", name: "Yes" },
  { slug: "no", name: "No" },
];
export const SCAN_ALLOW = [
  { slug: "1", name: "Yes" },
  { slug: "0", name: "No" },
];
export const SPECIAL_ONLY_FILTER = [
  { slug: "yes", name: "Yes" },
  { slug: "no", name: "No" },
];
export const SPECIAL_ONLY = [
  { slug: "1", name: "Yes" },
  { slug: "0", name: "No" },
];

export const ACHIEVEMENT_FILTER = [
  { slug: "yes", name: "Yes" },
  { slug: "no", name: "No" },
];
export const STATUS = [
  { slug: "1", name: "1" },
  { slug: "0", name: "0" },
];
export const REWARD_STATUS = [
  { slug: "yes", name: "Active" },
  { slug: "no", name: "Deactive" },
];
export const STATUS_YES_NO = [
  { slug: "1", name: "Yes" },
  { slug: "0", name: "No" },
];
export const STATUS_AD = [
  { slug: "1", name: "Active" },
  { slug: "0", name: "Deactive" },
];
export const CONDITION_TYPE = [
  { slug: "product_scan", name: "Product Scan" },
  { slug: "box_scan", name: "Box Scan" },
  { slug: "water_pumps_scan", name: "Water Pumps Scan" },
  { slug: "membranes_domestic_scan", name: "Membranes Domestic Scan" },
  { slug: "inline_scan", name: "Inline Scan" },
  { slug: "housing_scan", name: "Housing Scan" },
  { slug: "filters_scan", name: "Filters Scan" },
  { slug: "spun_filters_scan", name: "Spun Filters Scan" },
  { slug: "systems_scan", name: "Systems Scan" },
  { slug: "membranes_industrial_scan", name: "Membranes Industrial Scan" },
  { slug: "dosing_pumps_scan", name: "Dosing Pumps Scan" },
  { slug: "video", name: "Video" },
  { slug: "pdf", name: "PDF" },
  { slug: "earn_point", name: "Earn Point" },
  { slug: "reward_point_use", name: "Reward Point Use" },
  { slug: "gift_transfer", name: "Gift Transfer" },
  { slug: "currency_transfer", name: "Currency Transfer" },
  { slug: "earn_coins", name: "Earn Coins" },
  { slug: "referral_users", name: "Referral Users" },
];
export const REWARD_ALLOW_SCAN = [
  { slug: "yes", name: "Yes" },
  { slug: "no", name: "No" },
];
export const BONUS_POINT_ACHIEVED_STATUS = [
  { slug: "yes", name: "Yes" },
  { slug: "no", name: "No" },
];
export const SEMINAR_STATUS = [
  { slug: "yes", name: "Active" },
  { slug: "no", name: "Deactive" },
];
export const ATTEND_SEMINAR = [
  { slug: "yes", name: "Yes" },
  { slug: "no", name: "No" },
];
export const IS_SENT = [
  { slug: "yes", name: "Yes" },
  { slug: "no", name: "No" },
];
export const INTERESTED = [
  { slug: "yes", name: "Yes" },
  { slug: "no", name: "No" },
];
export const USER_VERIFY = [
  { slug: "1", name: "Yes" },
  { slug: "0", name: "No" },
];
export const USER_REMOVED = [
  { slug: "1", name: "Yes" },
  { slug: "0", name: "No" },
];
export const ACHIEVEMENT = [
  { slug: "1", name: "Yes" },
  { slug: "0", name: "No" },
];
export const CATEGORY_TYPE = [
  { slug: "domestic", name: "Domestic" },
  { slug: "industrial", name: "Industrial" },
];
export const WHATSAPP_MESSAGE_TYPE = [
  { slug: "scanning_report", name: "Scanning Report" },
  { slug: "scan_reminder", name: "Scan Reminder" },
  { slug: "product_transfer_reminder", name: "Product Transfer Reminder" },
  { slug: "product_claim", name: "Product Claim" },
  { slug: "product_transfer_sender", name: "Product Transfer (Sender)" },
  { slug: "product_transfer_receiver", name: "Product Transfer (Receiver)" },
  { slug: "other_product_scan", name: "Other Product Scan" },
  { slug: "birthday_anniversary", name: "Birthday Anniversary" },
  { slug: "reward_gift", name: "Reward Gift" },
];
export const getWhatsappMessageTypeObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = WHATSAPP_MESSAGE_TYPE.filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};
export const DELIVERY_STATUS = [
  { slug: "Delivered", name: "Delivered" },
  { slug: "Failed", name: "Failed" },
  { slug: "Pending", name: "Pending" },
  { slug: "Read", name: "Read" },
  { slug: "Sent", name: "Sent" },
];
export const ROLE_DEALER_SLUG = "dealer";
export const ROLE_SUB_DEALER_SLUG = "retailer";
export const ROLE_TECHNICIAN_SLUG = "technician";
export const GENERAL_TICKET_SLUG = "general";
export const ROLE_ADMIN_SLUG = "ALL";

export const TICKET_TYPE_LIST = (t) => {
  return [
    { slug: ROLE_DEALER_SLUG, name: t("dealer") },
    { slug: ROLE_SUB_DEALER_SLUG, name: t("sub_dealer") },
    { slug: ROLE_TECHNICIAN_SLUG, name: t("technician") },
    { slug: GENERAL_TICKET_SLUG, name: t("general") },
  ];
};
export const getTicketTypeObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = TICKET_TYPE_LIST(t).filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};
export const ROLE_LIST = (t) => {
  return [
    { slug: ROLE_DEALER_SLUG, name: t("dealer") },
    { slug: ROLE_SUB_DEALER_SLUG, name: t("sub_dealer") },
    { slug: ROLE_TECHNICIAN_SLUG, name: t("technician") },
  ];
};
export const CONDITION_TYPE_LIST = (t) => {
  return [
    { slug: "product_scan", name: t("product_scan") },
    { slug: "box_scan", name: t("box_scan") },
    { slug: "water_pumps_scan", name: t("water_pumps_scan") },
    { slug: "membranes_domestic_scan", name: t("membranes_domestic_scan") },
    { slug: "inline_scan", name: t("inline_scan") },
    { slug: "housing_scan", name: t("housing_scan") },
    { slug: "filters_scan", name: t("filters_scan") },
    { slug: "spun_filters_scan", name: t("spun_filters_scan") },
    { slug: "systems_scan", name: t("systems_scan") },
    { slug: "membranes_industrial_scan", name: t("membranes_industrial_scan") },
    { slug: "dosing_pumps_scan", name: t("dosing_pumps_scan") },
    { slug: "video", name: t("video") },
    { slug: "pdf", name: t("pdf") },
    { slug: "earn_point", name: t("earn_point") },
    { slug: "reward_point_use", name: t("reward_point_use") },
    { slug: "gift_transfer", name: t("gift_transfer") },
    { slug: "currency_transfer", name: t("currency_transfer") },
    { slug: "earn_coins", name: t("earn_coins") },
    { slug: "referral_users", name: t("referral_users") },
  ];
};
export const STATUS_OPTIONS = [
  { name: "Active", slug: "active" },
  { name: "Deactive", slug: "deactive" },
];
export const getRoleObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = ROLE_LIST(t).filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};
export const ALL_ROLE_LIST = (t) => {
  const allOption = [{ slug: "all", name: t("all") }];
  return [...allOption, ...ROLE_LIST(t)];
};
export const ALL_ROLE_LIST_WITH_CUSTOM = (t) => {
  const newOption = [
    { slug: "all", name: t("all") },
    { slug: "custom", name: t("custom") },
  ];
  return [...newOption, ...ROLE_LIST(t)];
};
export const getAllRoleObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = ALL_ROLE_LIST(t).filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};

export const TUTORIAL_ROLE_LIST = (t) => {
  return [
    { slug: ROLE_ADMIN_SLUG, name: t("all") },
    { slug: ROLE_DEALER_SLUG, name: t("dealer") },
    { slug: ROLE_SUB_DEALER_SLUG, name: t("sub_dealer") },
    { slug: ROLE_TECHNICIAN_SLUG, name: t("technician") },
  ];
};
export const getTutorialRoleObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = TUTORIAL_ROLE_LIST(t).filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};

// after and before

export const CART_REPORT_BEFORE = "before";
export const CART_REPORT_AFTER = "after";

export const CART_REPORT = (t) => {
  return [
    { slug: CART_REPORT_BEFORE, name: t("before") },
    { slug: CART_REPORT_AFTER, name: t("after") },
  ];
};
export const getCartReportObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = CART_REPORT(t).filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};

//startup banner

export const STARTUP_VIDEO = "video";
export const STARTUP_IMAGE = "image";
export const STARTUP_GIF = "gif";

export const STARTUP_BANNER_TYPE = (t) => {
  return [
    { slug: STARTUP_VIDEO, name: t("video") },
    { slug: STARTUP_IMAGE, name: t("image") },
    { slug: STARTUP_GIF, name: t("gif") },
  ];
};
export const getStartupBannerObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = STARTUP_BANNER_TYPE.filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};

export const SCAN_REWARD_TYPE_GIFT_SLUG = "gift";
export const SCAN_REWARD_TYPE_BONUS_POINT_SLUG = "bonus_point";
export const SCAN_REWARD_TYPE_LIST = (t) => {
  return [
    { slug: "gift", name: t("gift") },
    { slug: "bonus_point", name: t("bonus_point") },
  ];
};
export const NOTIFICATION_STATUS_OPTION_LIST = (t) => {
  return [
    { slug: "send", name: t("send") },
    { slug: "schedule", name: t("schedule") },
  ];
};
export function getConditionNameBySlug(slug) {
  const condition = CONDITION_TYPE.find((item) => item.slug === slug);
  return condition ? condition.name : null;
}
export const getConditionObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = CONDITION_TYPE_LIST(t).filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};
export const getScanRewardTypeObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = SCAN_REWARD_TYPE_LIST(t).filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};
export const SCAN_TYPE_LIST = (t) => {
  return [
    { slug: "box", name: t("box") },
    { slug: "product", name: t("product") },
  ];
};
export const TRANSACTION_TYPE_LIST = (t) => {
  return [
    { slug: "credit", name: t("credit") },
    { slug: "debit", name: t("debit") },
  ];
};

export const SCAN_CODE_SLUG = "scancode";
export const FIVE_STAR_REPORT_SLUG = "five_star_report";
export const SCAN_CODE_REPORT_TABLE_TYPE_OLD_SLUG = "old";
export const SCAN_CODE_REPORT_TABLE_TYPE_NEW_SLUG = "new";
export const SCAN_CODE_REPORT_TABLE_TYPE = [
  { slug: SCAN_CODE_REPORT_TABLE_TYPE_OLD_SLUG, name: "Old" },
  { slug: SCAN_CODE_REPORT_TABLE_TYPE_NEW_SLUG, name: "New" },
];
export const getScanCodeReportTableTypeObjBySlug = (t, slug) => {
  let selectedSlug = null;
  const filteredData = SCAN_CODE_REPORT_TABLE_TYPE.filter(function (item) {
    return item.slug == slug;
  });
  if (filteredData.length > 0) {
    selectedSlug = filteredData[0];
  }
  return selectedSlug;
};
// ticket
export const TICKET_STATUS_LIST = (t) => {
  return [
    { value: "open", label: t("Open") },
    { value: "closed", label: t("Close") },
    { value: "in_progress", label: t("In Progress") },
  ];
};
export const getTicketStatusObjByValue = (t, value) => {
  let selectedValue = null;
  const filteredData = TICKET_STATUS_LIST(t).filter(function (item) {
    return item.value == value;
  });
  if (filteredData.length > 0) {
    selectedValue = filteredData[0];
  }
  return selectedValue;
};

// Create a list of years dynamically
export const YEAR_LIST = (
  startYear = new Date().getFullYear(),
  length = 5,
  slug = "value",
  label = "label",
) => {
  const years = [];
  // Add previous years
  for (let i = -length; i < 0; i++) {
    years.push({
      [slug]: startYear + i,
      [label]: `${startYear + i}`,
    });
  }
  // Add current and future years
  for (let i = 0; i < length; i++) {
    years.push({
      [slug]: startYear + i,
      [label]: `${startYear + i}`,
    });
  }
  return years;
};

export const getYearObjByValue = (value, slug = "value", label = "label") => {
  const filteredData = YEAR_LIST(undefined, undefined, slug, label).filter(
    (item) => item[slug] == value,
  );
  return filteredData.length > 0 ? filteredData[0] : null;
};

//Priority
export const PRIORITY_STATUS_LIST = (t) => {
  return [
    { value: "low", label: t("Low") },
    { value: "medium", label: t("Medium") },
    { value: "high", label: t("High") },
  ];
};
export const getPriorityObjByValue = (t, value) => {
  let selectedValue = null;
  const filteredData = PRIORITY_STATUS_LIST(t).filter(function (item) {
    return item.value == value;
  });
  if (filteredData.length > 0) {
    selectedValue = filteredData[0];
  }
  return selectedValue;
};
//
// select brand
export const SELECT_BRAND = (t) => {
  return [
    { slug: "Lexcru", name: t("Lexcru") },
    { slug: "Lexpure", name: t("Lexpure") },
    { slug: "Cruze", name: t("Cruze") },
    { slug: "OEM", name: t("OEM") },
    { slug: "LCM", name: t("LCM") },
  ];
};
export const SELECT_BRAND_OPTION = (t) => {
  return [
    { slug: "Lexpure", name: t("Lexpure") },
    { slug: "Cruze", name: t("Cruze") },
  ];
};
export const SELECT_ALL_BRAND_OPTION = (t) => {
  return [
    { slug: "All", name: t("All") },
    { slug: "Lexpure", name: t("Lexpure") },
    { slug: "Cruze", name: t("Cruze") },
  ];
};
export const getbrandObjByValue = (t, value) => {
  let selectedValue = null;
  const filteredData = SELECT_BRAND(t).filter(function (item) {
    return item.value == value;
  });
  if (filteredData.length > 0) {
    selectedValue = filteredData[0];
  }
  return selectedValue;
};
// month dropdown
export const SELECT_MONTH = (t) => {
  return [
    { slug: "1", name: t("January") },
    { slug: "2", name: t("February") },
    { slug: "3", name: t("March") },
    { slug: "4", name: t("April") },
    { slug: "5", name: t("May") },
    { slug: "6", name: t("June") },
    { slug: "7", name: t("July") },
    { slug: "8", name: t("August") },
    { slug: "9", name: t("September") },
    { slug: "10", name: t("October") },
    { slug: "11", name: t("November") },
    { slug: "12", name: t("December") },
  ];
};
export const getmonthObjByValue = (t, value) => {
  let selectedValue = null;
  const filteredData = SELECT_MONTH(t).filter(function (item) {
    return item.value == value;
  });
  if (filteredData.length > 0) {
    selectedValue = filteredData[0];
  }
  return selectedValue;
};
export const generateYearOptions = (startYear) => {
  const currentYear = new Date().getFullYear();

  return Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
    const year = currentYear - i;
    return { label: year.toString(), value: year };
  });
};
export const BRAND_OPTIONS_LIST = (t) => {
  return [
    { slug: "Blueshell", name: t("blueshell") },
    { slug: "Cruze", name: t("cruze") },
    { slug: "Lexcru", name: t("lexcru") },
    { slug: "Lexpure", name: t("lexpure") },
    { slug: "OEM", name: t("oem") },
    { slug: "LCM", name: t("lcm") },
    { slug: "Export", name: t("export") },
    { slug: "Others", name: t("others") },
  ];
};
export const GLOBAL_SEARCH_TYPES = [
  {
    value: "name",
    label: "Name",
  },
  {
    value: "email",
    label: "Email",
  },
  {
    value: "mobile",
    label: "Mobile",
  },
  {
    value: "state",
    label: "State",
  },
  {
    value: "city",
    label: "City",
  },
  {
    value: "pincode",
    label: "Pincode",
  },
  { value: "district", label: "District" },
];
export const SCHEME_TYPES = [
  { slug: "2", name: "New" },
  { slug: "1", name: "Old" },
];
